<template>
  <MaxDocument :doc="artifact.doc" :labels="labels" :open-entity="openEntity" :can-open-entity="canOpenEntity">
    <template #actions>
      <button
        v-if="artifact.status === 'dismissed'"
        type="button"
        class="max-action"
        :disabled="busy"
        @click="emit('restore', artifact)"
      >{{ merged.artifact.restore }}</button>
      <button
        v-else
        type="button"
        class="max-action"
        :disabled="busy"
        @click="emit('dismiss', artifact)"
      >{{ merged.artifact.dismiss }}</button>
    </template>
    <template #meta>
      <span class="max-badge" data-intent="accent">{{ provenance }}</span>
    </template>
    <template #notice>
      <p v-if="artifact.status === 'dismissed'" class="max-notice" role="status">{{ merged.artifact.dismissed }}</p>
    </template>
  </MaxDocument>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mergeLabels, type MaxLabels } from '../core/labels.ts'
import type { MaxRenderContext } from '../runtime/context.ts'

export interface MaxArtifactRecord {
  id: number
  kind: string
  title: string
  source: 'johku_staff' | 'schedule' | 'merchant' | string
  status: 'new' | 'read' | 'dismissed' | string
  doc: unknown
}

const props = withDefaults(defineProps<{
  artifact: MaxArtifactRecord
  labels?: Partial<MaxLabels> | null
  busy?: boolean
  openEntity?: MaxRenderContext['openEntity']
  canOpenEntity?: MaxRenderContext['canOpenEntity']
}>(), {
  labels: null,
  busy: false,
  openEntity: undefined,
  canOpenEntity: undefined
})

const emit = defineEmits<{
  dismiss: [artifact: MaxArtifactRecord]
  restore: [artifact: MaxArtifactRecord]
}>()

const merged = computed(() => mergeLabels(props.labels))

const provenance = computed(() => {
  const key = `source_${props.artifact.source}` as keyof MaxLabels['artifact']
  return merged.value.artifact[key] ?? merged.value.artifact.source_johku_staff
})
</script>
